/**
 * Just an list of module reducers to decouple them from combineReducers method
 */

import auth from './auth';
import emailVerification, {
  EmailVerificationPartialState,
} from './emailVerification';
import payoutSettings, { PayoutSettingsPartialState } from './payoutSettings';
import recovery, { RecoveryPartialState } from './recovery';
import registration, { RegistrationPartialState } from './registration';
import user, { UserPartialState } from './user';

export type CommonUsersState = EmailVerificationPartialState &
  PayoutSettingsPartialState &
  RecoveryPartialState &
  RegistrationPartialState &
  UserPartialState;

export default {
  auth,
  emailVerification,
  payoutSettings,
  recovery,
  registration,
  user,
};
